export default __webpack_public_path__ + "static/media/logosvg.680639e1.svg";